import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function ACardInfoItem({
	src,
	label,
	value,
	className,
}) {
	return (
		<div className={`a-card-info-item ${className}`}>
			<img
				src={src}
				alt=""
				className={`info-image ${className}`}
			/>
			<p className="font-size-sm">
				<FormattedMessage id={label} values={{ value }} />
			</p>
		</div>
	);
}

ACardInfoItem.propTypes = {
	src: PropTypes.string,
	value: PropTypes.string,
	label: PropTypes.string,
	className: PropTypes.string,
};

ACardInfoItem.defaultProps = {
	src: '',
	label: '',
	value: '',
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.card-info-item.js